import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../App";

const ClinicSettingsContext = createContext(null);

export const useClinicSettings = () => useContext(ClinicSettingsContext);

export function ClinicSettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    clinic_name: "ItapeviDents",
    clinic_logo: null,
    open_time: "08:00",
    close_time: "18:00",
    slot_duration: 30,
  });

  const fetchSettings = useCallback(async () => {
    try {
      const res = await api.get("/auth/clinic-settings");
      setSettings(prev => ({ ...prev, ...res.data }));
    } catch {}
  }, []);

  const updateSettings = useCallback((newSettings) => {
    setSettings(prev => ({ ...prev, ...newSettings }));
  }, []);

  return (
    <ClinicSettingsContext.Provider value={{ settings, fetchSettings, updateSettings }}>
      {children}
    </ClinicSettingsContext.Provider>
  );
}
